import { Reg_Documents } from "@/store/wp_planner/documents/registered.store"
import { App_Documents } from "@/store/wp_planner/documents/appeals.store"
import { Mai_Documents } from "@/store/wp_planner/documents/maintenance.store";
import {EventsList} from "@/store/wp_planner/events.store";
import {InfoBlock} from "@/store/wp_planner/info.store";
import {LeftDrawer, RightDrawer} from "@/store/wp_planner/misc.store";
import {CurrentPeriod} from "@/store/wp_planner/main.store";
import moment from "moment/moment";

export async function update_reg(token, district, year, week) {
    await Reg_Documents().update(token, district, year, week)
}

export async function update_all(token, district, year, week) {
    await Reg_Documents().update(token, district, year, week)
    await App_Documents().update(token, district, year, week)
    await Mai_Documents().update(token, district, year, week)
    await EventsList().update(token, district, year, week)
}

export async function clear_all() {
    console.log('Очищаем предыдущие данные!')
    await Reg_Documents().set([])
    await App_Documents().set([])
    await Mai_Documents().set([])
    await EventsList().set([])
    InfoBlock().set(null)
    LeftDrawer().set(null)
    RightDrawer().set(null)
    CurrentPeriod().set(moment().startOf('week'))
}
